module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "start"
  }, [_c('div', {
    staticClass: "Slide"
  }, [_c('header', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "NewsWrapper"
  }, [_c('div', {
    staticClass: "News"
  }, [_c('p', [_vm._v("更新情報")]), _vm._v(" "), _c('ul', {
    staticClass: "NewsSlider"
  }, _vm._l((_vm.posts), function(post) {
    return _c('news-list', {
      attrs: {
        "post": post
      }
    })
  }))]), _vm._v(" "), _c('p', {
    staticClass: "ToBlog"
  }, [_c('a', {
    attrs: {
      "href": _vm.home_url + 'blog/'
    }
  }, [_vm._v("≫ ブログ一覧を見る")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('img', {
    attrs: {
      "src": require("../assets/images/common/logo.svg"),
      "alt": "おやこハグネット"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a7e6471!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/HeaderSlide.vue
// module id = 382
// module chunks = 2